import axios from "@/axios";
import * as types from '../mutation-types';

export default {
    namespaced: true,

    state: {
        leaves: [],
        permissions: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('settingsHr/leavesOrPermissionType').then(({ data }) => {
                commit(types.STORE_LEAVES_TYPE, data)
                commit(types.STORE_PERMISSION_TYPE, data)
                return data
            })
        },

        create({ commit }, { name, maxDayCount, withSalary, discountPercentage, repetition, type, employeeIds, forAllEmployee }) {
            return axios.post('/SettingsHr/LeavesOrPermissionType', {
                name, maxDayCount, withSalary, discountPercentage, repetition, type, employeeIds, forAllEmployee
            }).then((data) => {
                return data
            })
        },

        update({ commit }, { id, name, maxDayCount, withSalary, discountPercentage, repetition, type, employeeIds, forAllEmployee }) {
            return axios.put(`/SettingsHr/LeavesOrPermissionType/${id}`, {
                name, maxDayCount, withSalary, discountPercentage, repetition, type, employeeIds, forAllEmployee
            }).then(({ data }) => {
                return data
            })
        },

        delete({ commit }, { id }) {
            return axios.delete(`/SettingsHr/LeavesOrPermissionType/${id}`)
        },

        fetchLeaveBalanceById({ commit }, { id }) { 
            return axios.get(`/Leaves/Employee/LeaveBalance/${id}`).then(({ data }) => {
                return data
            })
        }
    },

    mutations: {
        // [types.STORE_LEAVES_OR_PERMISSIONS_TYPES](state, types) {
        //     state.types = types
        // }
        [types.STORE_LEAVES_TYPE](state, leaves) {
            state.leaves =  leaves.filter(c => c.type === 0)
        },
        [types.STORE_PERMISSION_TYPE](state, permissions) {
            state.permissions =  permissions.filter(c => c.type === 1)
        },
    },

    getters: {
        getLeavesById: state => id => state.leaves.find(c => c.id === id)
    }
}
